// Lightweight gender detection from an Italian first name.
// Returns "f" (femminile) or "m" (maschile). In dubbio → "m" (richiesta esplicita Laura, 27/05/2026).
//
// Rules:
//   1) Hard overrides for ambiguous Italian names (rare exceptions to the -a rule).
//   2) Default: names ending in "a" → femminile, everything else → maschile.

const MALE_OVERRIDES = new Set([
  "andrea", "luca", "nicola", "simone", "daniele", "mattia", "elia",
  "tobia", "mose", "mosè", "isaia", "noè", "samuele", "michele",
  "gabriele", "raffaele", "ezechia", "geremia",
]);

const FEMALE_OVERRIDES = new Set([
  // Female names NOT ending in -a (rare in Italian)
  "beatrice", "alice", "agnese", "rachele", "irene", "eloise", "eleonor",
  "lou", "naomi", "rebecca", "ester", "ruth",
]);

export function detectGender(name) {
  if (!name || typeof name !== "string") return "m";
  const first = name.trim().split(/\s+/)[0].toLowerCase();
  if (!first) return "m";
  if (MALE_OVERRIDES.has(first)) return "m";
  if (FEMALE_OVERRIDES.has(first)) return "f";
  return first.endsWith("a") ? "f" : "m";
}

export function selfDiscoveryPhrase(name) {
  return detectGender(name) === "f" ? "scopri te stessa" : "scopri te stesso";
}

export function readyToDiscoverPhrase(name) {
  return detectGender(name) === "f"
    ? "Pronta a scoprire te stessa?"
    : "Pronto a scoprire te stesso?";
}
